import { render, staticRenderFns } from "./ImageCategoriesDisplay.vue?vue&type=template&id=333e6c70&scoped=true"
import script from "./ImageCategoriesDisplay.vue?vue&type=script&lang=js"
export * from "./ImageCategoriesDisplay.vue?vue&type=script&lang=js"
import style0 from "./ImageCategoriesDisplay.vue?vue&type=style&index=0&id=333e6c70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333e6c70",
  null
  
)

export default component.exports